import { render, staticRenderFns } from "./simple-image-text-right.vue?vue&type=template&id=524eac94&scoped=true"
import script from "./simple-image-text-right.vue?vue&type=script&lang=js"
export * from "./simple-image-text-right.vue?vue&type=script&lang=js"
import style0 from "./simple-image-text-right.vue?vue&type=style&index=0&id=524eac94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524eac94",
  null
  
)

export default component.exports